import type {default as Hls} from 'hls.js';

import {safeAccess} from '../../utils/objectUtils';

export class HlsjsPlayerProxy {
  constructor(private readonly rawPlayer: Hls) {}

  on = (...args: Parameters<Hls['on']>) => safeAccess(() => this.rawPlayer.on(...args));

  get media() {
    return safeAccess(() => this.rawPlayer.media);
  }

  get url() {
    return safeAccess(() => this.rawPlayer.url);
  }

  get levels() {
    return safeAccess(() => this.rawPlayer.levels);
  }

  get currentLevel() {
    return safeAccess(() => this.rawPlayer.currentLevel);
  }

  get audioTrack() {
    return safeAccess(() => this.rawPlayer.audioTrack);
  }

  get audioTracks() {
    return safeAccess(() => this.rawPlayer.audioTracks);
  }

  get subtitleDisplay() {
    return safeAccess(() => this.rawPlayer.subtitleDisplay);
  }

  get subtitleTrack() {
    return safeAccess(() => this.rawPlayer.subtitleTrack);
  }

  get subtitleTracks() {
    return safeAccess(() => this.rawPlayer.subtitleTracks);
  }

  get version(): string | undefined {
    return safeAccess(() => (this.rawPlayer as any).constructor.version);
  }
}
